
<h2>Active Brands<button class="icon--renew btn--default" (click)="refreshBrands()">Refresh</button><button class="icon--remove btn--default" *ngIf="canDelete()" (click)="deleteExistingBrands()">Remove Brand(s)</button></h2>
<table class="mvd_table--primeng" *ngIf="dataLoaded">
    <thead>
        <tr>
            <th>State</th>
            <th>Brand</th>
            <th class="w--date">Effective Date</th>
            <!--<th>End Date</th>-->
            <!--<th class="w--icon">Delete</th>-->
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let b of vehicleBrands;">
            <td>{{b.jurisdictionID | displayValue:jurisdictions}}</td>
            <td>{{b.brandID | displayValue:brands}}</td>
            <td>{{b.effectiveDate | date:'M/d/yyyy'}}</td>

            <!--<td>{{b.endDate | shortDate}}</td>-->
            <!--refer CHANGE CONTROL 52269, should be able to delete any existing brand-->
            <!--<td class="w--icon"><a class="icon--delete" href="javascript:void(0)" (click)="deleteExistingBrand(b.id)" *ngIf="canDelete(b.jurisdictionID, b.id)"></a></td>-->
        </tr>
        <tr *ngIf="!vehicleBrands.length">
            <td colspan="3">No Active Brands</td>
        </tr>
    </tbody>

</table>
<h2 *ngIf="nmvtisBrands && nmvtisBrands.length">Nmvtis Brands</h2>
<table class="mvd_table--primeng" *ngIf="dataLoaded && nmvtisBrands && nmvtisBrands.length">
    <thead>
        <tr>
            <th>State</th>
            <th>Brand</th>
            <th class="w--date">Effective Date</th>
            <!--<th class="w--date">End Date</th>-->
            <!--<th class="w--icon">Delete</th>-->
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let b of nmvtisBrands;">
            <td>{{b.jurisdictionID | displayValue:jurisdictions}}</td>
            <td>{{b.brandID | displayValue:brands}}</td>
            <td>{{b.effectiveDate | date:'M/d/yyyy'}}</td>
            <!--<td>{{b.endDate | shortDate}}</td>-->
        </tr>
    </tbody>
</table>

<ng-container *ngIf="dataLoaded && enableAddBrand">
    <h2>New/Carryover Brand
    <button *ngIf="dataLoaded && !showBrands" class="icon--add btn--default" href="javascript:void(0)" title="Add A Brand" (click)="showBrand()"> Add Brand</button>
    <button *ngIf="dataLoaded && showBrands" class="icon--spinner btn--default" href="javascript:void(0)" title="Remove" (click)="hideBrand()"> Undo Add Brand</button>
    </h2>
    <fieldset>
        <div class="row" *ngIf="showBrands">
            <div class="col-sm-5 col-md-4 col-lg-3 mvd_form-group">
                <label>Brand</label>
                <select class="mvd_form-control" [(ngModel)]="newVehicleBrand.brandID" (change)="setEffectiveDate()">
                    <option [ngValue]="0" selected="selected">Select</option>
                    <option *ngFor="let brand of filteredBrands" [ngValue]="brand.id">{{brand.displayValue}}</option>
                </select>
            </div>
            <div class="col-sm-4 col-md-3 col-lg-2 mvd_form-group" *ngIf="dataLoaded && newVehicleBrand.brandID > 0">
                <label>Effective Date</label>
                <div class="mvd_form-control" *ngIf="showBrands">{{newVehicleBrand.effectiveDate | date:'M/d/yyyy'}}</div>
                <!--<p-calendar id="effectiveDate" [ngModel]="newVehicleBrand.effectiveDateString" (onInput)="inputEffectiveDateFormatted(newVehicleBrand, $event)" (onSelect)="setEffectiveDateFormatted(newVehicleBrand, $event)" [showIcon]="true"></p-calendar>-->
            </div>
        </div>
    </fieldset>
</ng-container>